<template>
  <div class="marge-tab">
    <!-- Marge tab -->
    <v-layout justify-space-between>
      <v-flex sm5>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Libellé</th>
                <th>Montant</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Coût fabriqué</td>
                <td>{{ project.manufactured_cost | currency }}</td>
              </tr>
              <tr>
                <td>Prix de vente d’un support</td>
                <td>{{ project.bracket_buy_price | currency }}</td>
              </tr>
              <tr>
                <td>Prix d’achat d’un support</td>
                <td>{{ project.bracket_buy_price | currency }}</td>
              </tr>
              <tr>
                <td>CA coût fabriqué (CA coût fabriqué -prix de vente)</td>
                <td>{{ project.ca_manufactured_cost | currency }}</td>
              </tr>
              <tr>
                <td>Coefficient matière première</td>
                <td>{{ project.raw_material_coefficient }}</td>
              </tr>
              <tr>
                <td>
                  Forfait matière première (Coefficient matière première x CA
                  coût fabriqué)
                </td>
                <td>{{ project.raw_material_fixed_price | currency }}</td>
              </tr>
              <tr>
                <td>
                  Coût horaire
                </td>
                <td>{{ project.manpower_hourly_cost | currency }}</td>
              </tr>
              <tr>
                <td>
                  Nombre d’heure totales travaillées
                </td>
                <td>{{ project.real_finishing_time }}</td>
              </tr>
              <tr>
                <td>
                  Total coût nombres d’heures
                </td>
                <td>{{ project.total_manpower | currency }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
      <v-flex sm7 pa-12>
        <p>Marge instantanée : {{ project.instant_margin | currency }}</p>
        <p>Marge : {{ project.margin_percent }} %</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: "MargeTab",
    props: {
      project: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss">
  .marge-tab {
    height: calc(100vh - 246px - 30px - 40px - 64px - 48px - 16px - 110px);
    .v-data-table {
      table {
        tr {
          td {
            color: #707070 !important;
            &:first-child {
              color: #707070 !important;
              border-right: 1px solid #707070;
            }
          }
        }
      }
    }
    p {
      font-size: 18px !important;
    }
  }
</style>
